module.exports = __webpack_public_path__ + "static/media/a230d036.jpg";